<template>
    <v-row>
        <v-col md="12">
          <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                        <tr class="grayC">
                            <th v-if="$route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard'">
                              <v-checkbox v-model="checkboxAll" disabled @change="checkboxUpdated()"></v-checkbox>
                              </th>
                            <th>{{ $t("unPaidRegistration.registrant") }}</th>
                            <th>{{ $t("unPaidRegistration.details") }}</th>
                            <th v-if="summaryItems.registrationType != 2">{{ $t("unPaidRegistration.number") }}</th>
                            <th>{{ $t("unPaidRegistration.taxed") }}</th>
                            <th></th>
                            <th>{{ $t("unPaidRegistration.price") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(mem,index) in summaryItems.registrants" :key="index">
                            <td v-if="$route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard'">
                              <div v-if="mem.isUserId == 1">
                                <v-checkbox v-if="mem.id == userId || mem.userId == userId" disabled v-model="checkbox_" :class="'class_'+mem.userId" :value="mem.item+'-'+mem.userId+'-'+mem.id" @change="mem.checked = !mem.checked;checkboxUpdated_($event, mem)" ></v-checkbox>
                                <v-checkbox v-else v-model="checkbox_" disabled :value="mem.item+'-'+mem.userId+'-'+mem.id" :class="'class_'+mem.userId" @change="mem.checked = !mem.checked;checkboxUpdated_($event, mem)" ></v-checkbox>
                              </div>
                            </td>
                            <td>
                              <div v-if="mem.isUserId == 1"> {{ mem.name}}</div>
                              <div v-else-if="mem.name && mem.name.length > 0"> {{ mem.name }}</div>
                              <div v-else> {{ $t("unPaidRegistration.family_friends") }}</div>
                            </td>
                            <td v-if="mem.isUserId == 1 && mem.className == '[___Event Practice___]'">{{ $t("unPaidRegistration.event_practice") }}</td>
                            <td v-if="mem.isUserId == 1 && mem.className != '[___Event Practice___]'">
                              <div>{{ $t("unPaidRegistration.class") }}: {{ mem.className }}</div>
                              <div v-if="mem.eventPricingText">{{ $t("unPaidRegistration.event_pricing") }}: {{ mem.eventPricingText }}</div>
                            </td>
                            <td v-if="mem.isUserId == 0">
                              <div>{{ mem.className }}</div>
                              <div v-if="mem.eventPricingText">{{ $t("unPaidRegistration.event_pricing") }}: {{ mem.eventPricingText }}</div>
                            </td>
                            <td v-if="summaryItems.registrationType != 2" :style="`color:${danger}`">{{ mem.number }}</td>
                            <td v-if="!mem.taxed">{{ $t("unPaidRegistration.no") }}</td>
                            <td v-if="mem.taxed">{{ $t("unPaidRegistration.yes") }}</td>
                            <td></td>
                            <td>${{ mem.cost }}</td>
                        </tr>
                        <tr v-if="discountBand">
                            <td :colspan="5" v-if="$route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard'">&nbsp;</td>
                            <td :colspan="4" v-if="$route.name != 'UnPaidRegistration' && $route.name != 'UnPaidRegistrationDashboard'">&nbsp;</td>
                            <td class="grayC">{{ discountCode }}</td>
                            <td class="grayC" v-if="registrants == 1">- ${{ totalDisc }}</td>
                            <td class="grayC" v-if="registrants == 0 || registrants > 1">- ${{ totalDiscCoupon }}</td>
                        </tr>
                        <tr>
                            <td :colspan="5" v-if="summaryItems.registrationType != 2 && ($route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard')">&nbsp;</td>
                            <td :colspan="4" v-if="
                                (summaryItems.registrationType == 2 && ($route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard')) || 
                                (summaryItems.registrationType != 2 && ($route.name != 'UnPaidRegistration' && $route.name != 'UnPaidRegistrationDashboard'))
                              ">&nbsp;</td>
                            <td :colspan="3" v-if="summaryItems.registrationType == 2 && ($route.name != 'UnPaidRegistration' && $route.name != 'UnPaidRegistrationDashboard')">&nbsp;</td>
                            <td class="grayC">{{ $t("unPaidRegistration.subtotal") }}</td>
                            <td class="grayC" v-if="registrants == 1" >${{ summaryItems.subtotal }}</td>
                            <td class="grayC" v-if="registrants == 0 || registrants > 1" >${{ subtotal }}</td>
                        </tr>
                        <tr v-if="!(taxes && Array.isArray(taxes) && taxes.length > 0)">
                            <td :colspan="5" v-if="summaryItems.registrationType != 2 && ($route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard')">&nbsp;</td>
                            <td :colspan="4" v-if="
                                (summaryItems.registrationType == 2 && ($route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard')) || 
                                (summaryItems.registrationType != 2 && ($route.name != 'UnPaidRegistration' && $route.name != 'UnPaidRegistrationDashboard'))
                              ">&nbsp;</td>
                            <td :colspan="3" v-if="summaryItems.registrationType == 2 && ($route.name != 'UnPaidRegistration' && $route.name != 'UnPaidRegistrationDashboard')">&nbsp;</td>
                            <td class="grayC">{{ $t("unPaidRegistration.tax") }}</td>
                            <td class="grayC">${{ tax }}</td>
                        </tr>
                        <template v-else v-for="(taxItem,i) in taxes">
                          <tr :key="`tax-${i}`">
                            <td :colspan="5" v-if="summaryItems.registrationType != 2 && ($route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard')">&nbsp;</td>
                            <td :colspan="4" v-if="
                                (summaryItems.registrationType == 2 && ($route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard')) || 
                                (summaryItems.registrationType != 2 && ($route.name != 'UnPaidRegistration' && $route.name != 'UnPaidRegistrationDashboard'))
                              ">&nbsp;</td>
                            <td :colspan="3" v-if="summaryItems.registrationType == 2 && ($route.name != 'UnPaidRegistration' && $route.name != 'UnPaidRegistrationDashboard')">&nbsp;</td>
                            <td class="grayC">{{ $t("unPaidRegistration.tax") }} {{taxItem.taxLabel}} <span v-if="taxItem.taxNumber != null">({{taxItem.taxNumber}})</span></td>
                            <td class="grayC">${{ taxItem.taxAmount }}</td>
                          </tr>
                        </template>
                        <tr>
                          <td :colspan="5" v-if="summaryItems.registrationType != 2 && ($route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard')">&nbsp;</td>
                            <td :colspan="4" v-if="
                                (summaryItems.registrationType == 2 && ($route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard')) || 
                                (summaryItems.registrationType != 2 && ($route.name != 'UnPaidRegistration' && $route.name != 'UnPaidRegistrationDashboard'))
                              ">&nbsp;</td>
                            <td :colspan="3" v-if="summaryItems.registrationType == 2 && ($route.name != 'UnPaidRegistration' && $route.name != 'UnPaidRegistrationDashboard')">&nbsp;</td>
                            <td class="grayC">{{ $t("unPaidRegistration.total") }}</td>
                            <td class="grayC" v-if="registrants == 1" >${{ summaryItems.total }}</td>
                            <td class="grayC" v-if="registrants == 0 || registrants > 1" >${{ total }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>   
        </v-col>
        <v-col cols="12" class="mt-4" v-if="registrationType == 1 && ($route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard')">
          <v-checkbox :color="`${buttonColor}`" v-model="acceptSummary" :label="$t('registerEvent.accept_summary')" :disabled="registeredBy != userId" style="float: right"></v-checkbox>
        </v-col>
        <v-col md="12">
          <v-row>
            <v-col md="2" cols="12"></v-col>
            <v-col md="10" cols="12" class="buttons"> 
              <v-row no-gutters v-if="$route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard'">
                <v-col class="cont-inp-promo" style="">
                  <v-text-field
                    v-model="promoCode"
                    required
                    filled outlined dense
                    :label="$t('unPaidRegistration.promo-code')"
                    :class="`mr-2 ${bandError ? 'errorPromo' : ''}`"
                    style="display: inline"
                    :disabled="registeredBy != userId"
                    maxLength="40"
                  ></v-text-field>        
                </v-col>
                <v-col class="cont-btn-promo">
                  <v-btn
                    :color="`${buttonColor}`"
                    class="btn_next"
                    large
                    @click="validate_promo()"
                  >{{ $t('unPaidRegistration.apply-promo-code') }}</v-btn>
            </v-col>
          </v-row>
            </v-col>
          </v-row>
          <v-row v-if="$route.name == 'UnPaidRegistration' || $route.name == 'UnPaidRegistrationDashboard'">
            <v-col md="3" cols="12"></v-col>
            <v-col md="9" cols="12" class="buttons">
              <v-btn
                :color="`${danger}`"
                class="btn_next"
                large
                @click="cancel_registration()"
                  style="margin-left: auto;"
              >{{ $t("unPaidRegistration.cancel_registration") }}</v-btn>           
              <v-btn
                :color="`${buttonColor}`"
                class="btn_next"
                large
                @click="pay_now()"
                :disabled="disabledBtnPayment"
              >{{ total > 0 ? $t("unPaidRegistration.pay_now") : $t("unPaidRegistration.pay_now_zero") }}</v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-snackbar 
            v-model="snackbar" 
            :multi-line="multiLine"
            :timeout="-1"  
            top class="pt-16"
            :color="color_snackbar"
        >
          {{ msg_snackbar }}
          <template v-slot:action="{ attrs }">
            <v-btn 
              :color="`${buttonColor}`"
              v-bind="attrs"
              @click="close"
            > {{ $t("common.ok") }}
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar 
            v-model="snackbar_" 
            :multi-line="multiLine"
            :timeout="-1"  
            top class="pt-16"    
        >
          {{ $t("unPaidRegistration.warning_txt_cancel") }}
          <template v-slot:action="{ attrs }">
            <v-btn 
              :color="`${buttonColor}`"
              v-bind="attrs"
              style="margin-right: 10px;"
              @click="cancel_reg"
            >
              {{ $t("unPaidRegistration.yes") }}
            </v-btn>
            <v-btn 
              :color="`${buttonColor}`"
              v-bind="attrs"
              @click="close"
            >
              {{ $t("unPaidRegistration.no") }}
            </v-btn>
          </template>
        </v-snackbar>
    </v-row>
</template>

<script>
import PaymentService from "../../services/PaymentService";
import AuthService from "../../services/AuthService";
import { VBtn, VSnackbar, VRow, VCol, VSimpleTable, VCheckbox, VTextField } from 'vuetify/lib';
import LanguageService from '@/services/LanguageService';
export default {
  components: {
    VBtn, VSnackbar, VRow, VCol, VSimpleTable, VCheckbox, VTextField
  },
  props: ["eventId","regId","discount","platformName"],
  data() {
    return {
        selected: [],
        summaryItems: [],
        userId: null,
        buttonColor: null,
        danger: null,
        singleSelect: true,
        tax:0,
        subtotal: 0,
        subtotalAux: 0,
        total: 0,
        totalAux: 0,
        registrants: null,
        checkboxAll: false,
        checkboxAllAux: false,
        checkbox_: [],
        checkbox_Aux: [],
        snackName: '',
        snackbar_: false,
        multiLine: true,
        snackbar: false,
        msg_snackbar: "",
        color_snackbar: "",
        vertical: true,
        registrantsItems: [],
        acceptSummary: false,
        promoCode: null,
        registrationType: -1,
        discount_: null,
        couponPrice: 0,
        registeredBy: -1,
        taxes: [],
        bandError: false
    };
  },
  mounted() {},
  computed: {
    headers(){
      return [
        {
          text: this.$t("unPaidRegistration.registrant"),
          value: "name"
        },
        {
          text: this.$t("unPaidRegistration.details"),
          value: "className"
        },
        {
          text: this.$t("unPaidRegistration.number"),
          value: "number"
        },
        {
          text: this.$t("unPaidRegistration.taxed"),
          value: "taxed"
        },
        {
          text: '',
          value: ''
        },
        {
          text: this.$t("unPaidRegistration.price"),
          value: "cost"
        }
      ]
    },
    disabledBtnPayment() {
      if(this.registrationType == 1 && !this.acceptSummary || this.registeredBy != this.userId)
        return true;
      return false;
    },
    totalDisc() {
      let discount = this.discount_ ? this.discount_ : (this.discount ? this.discount : false);
      if(discount && discount.codeType == "02") {
        const perc = this.summaryItems.couponPrice;
        return parseFloat(perc).toFixed(2);
    }
      return parseFloat(discount.value).toFixed(2);
  },
    discountBand() {
      return this.discount || this.discount_;
    },
    discountCode() {
      let discount = this.discount_ ? this.discount_ : (this.discount ? this.discount : { code: "" });
      return discount.code;
    },
    totalDiscCoupon() {
      let discount = this.couponPrice ? this.couponPrice : 0;
      return parseFloat(discount).toFixed(2);
    }
  },
  created: function() {
    this.navigationBGColor = this.$store.getters.env.get('VUE_APP_BACKGROUND_MENU_ACTIVE');
    this.getUser();
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.danger = this.$store.getters.env.get('VUE_APP_BUTTON_DANGER_COLOR');
  },
  methods: {
    async getQueuePayment(){
      var QueueId = await PaymentService.getQueuePayment();
      this.QueueId = QueueId.data;
      return this.getQueueTimer();
    }, 
    async getQueueTimer(){""
      var timer = await PaymentService.getQueueTimer(this.QueueId);
      return timer.data;            
    },
    async registerEventPending(eventId){
      await PaymentService.registerEventPending(eventId, this.userId);
    },
    close(){
      this.snackbar_ = false;
      this.checkboxAll = this.checkboxAllAux;
      this.checkbox_ = this.checkbox_Aux;
      this.total = this.totalAux;
      this.subtotal = this.subtotalAux;
    },
    cancel_reg(){
      LanguageService.postSetSession({ languageCode: this.$i18n.locale }).then((resp) => {
        window.location.href = this.$store.getters.env.get('VUE_APP_BASE') + 'cancelRegistration?eId='+this.eventId;
        if(resp.data.success) {
          this.$store.dispatch('setLanguageId', resp.data.message.id);
        }
        this.$store.dispatch('setLanguageCode', this.$i18n.locale);
      });
    },
    cancel_registration(){
      this.snackbar_ = true;
      this.checkboxAllAux = this.checkboxAll;
      this.checkbox_Aux = this.checkbox_;
      this.subtotalAux = this.subtotal;
      this.totalAux = this.total;
      this.total = 0;
      this.subtotal = 0;
      this.checkboxAll = true;
      this.checkbox_ = [];

      for(var i = 0; i < this.registrants; i ++){
        this.checkbox_.push(this.summaryItems.registrants[i].item+'-'+this.summaryItems.registrants[i].userId+'-'+this.summaryItems.registrants[i].id);        
        this.subtotal += parseFloat(this.summaryItems.registrants[i].cost); 
      }

      this.total = parseFloat(this.summaryItems.tax) + this.subtotal;
      this.subtotal = this.subtotal.toFixed(2);
      this.total = this.total.toFixed(2);

      
    },
    async pay_now(){
      if(this.checkbox_.length == 0){
        this.color_snackbar = "error";
        this.msg_snackbar = this.$t("unPaidRegistration.null_registrants");
        this.snackbar = true;
        setTimeout(() => this.snackbar = false, 3000);
      } else {
                
        var path= "";

        if(this.$route.name == 'UnPaidRegistration'){
          path = 'Payment';
        } else {
          path = 'PaymentDashboard';
        }
                
        this.$emit("summaryItems", this.summaryItems);        
        this.registerEventPending(this.eventId);
        var timer = await this.getQueuePayment();
                
        let aux = this.checkbox_.filter((el, i) => {
          return this.checkbox_.indexOf(el) == i;
        });
        let auxVerify = aux.filter((el) => {
          let id = el.split("-")[1];
          if(id == "") {
            return true;
          }
          let find = this.summaryItems.registrants.filter((item) => {
            return item.userId == id && item.isUserId && item.checked;
          });
          if(find.length > 0) {
            return true;
          }
          return false;
        });
        let auxSort = auxVerify.sort();

        //Validate is free
        if(this.total == 0){
          if(this.platformName == 'Stripe'){
              const response = await fetch(`${this.$store.getters.env.get('VUE_APP_DEV_API_HOST')}/laravel/public/api/v1/livelaps/stripe/eventRegistrationPayment/${this.regId}`);
              const data = await response.json();                        
              if (data.url) {
                  window.location.href = data.url;
              } 
          } else {
            window.location.href = `${this.$store.getters.env.get('VUE_APP_DEV_API_HOST')}/laravel/public/api/v1/livelaps/eventRegistrationPayment/${this.regId}`;
          }
        }else{
          this.$router.push({
              name: path,
              query: { eventId: this.eventId,
                      regId: this.regId,
                      timer: timer,
                      registrants: auxSort.join(',') },

          });
        }
      }
    },
    checkboxUpdated_(val, item) {      
      const registrants = this.summaryItems.registrants.filter((el) => {
        return el.checked && el.id;
      });
      this.refreshSubItem();
      const arrayBuddies = registrants.map((el) => {
        return el.id;
      });

      const buddies = arrayBuddies.toString();
      PaymentService.registerEventSummary(this.eventId,this.userId,buddies).then(response => {
        if(response.data.success){
            this.total = parseFloat(response.data.message.total).toFixed(2);
            this.subtotal = parseFloat(response.data.message.subtotal).toFixed(2);
            this.tax = parseFloat(response.data.message.tax).toFixed(2);
            this.couponPrice = parseFloat(response.data.message.couponPrice).toFixed(2);
        } else {
      let _itemsFilter = this.registrantsItems.filter(x => x.userId == item.id);
      let _sumItems = 0;
      _itemsFilter.forEach(element => {
        _sumItems = parseFloat(_sumItems) + parseFloat(element.cost);
      });      
      if(!item.checked){
        this.subtotal = parseFloat(this.subtotal) - parseFloat(_sumItems);
        this.total = parseFloat(this.total) - parseFloat(_sumItems);
      }else{        
        this.subtotal = parseFloat(this.subtotal) + parseFloat(_sumItems);
        this.total = parseFloat(this.total) + parseFloat(_sumItems);
      }
      this.subtotal = parseFloat(this.subtotal).toFixed(2);
      this.total = parseFloat(this.total).toFixed(2);      
        } 
      });   
    },
    checkboxUpdated(newValue){
      if(this.checkboxAll) {
        const long = this.summaryItems.registrants.length;
        this.checkbox_ = [];
        for(let i = 0; i < long; i++) {
          this.summaryItems.registrants[i].checked = true;
          this.checkbox_.push(this.summaryItems.registrants[i].item+'-'+this.summaryItems.registrants[i].userId+'-'+this.summaryItems.registrants[i].id);        
        }
        this.subtotal = this.summaryItems.subtotal;
        this.tax = this.summaryItems.tax;
        this.total = this.summaryItems.total;
        this.couponPrice = this.summaryItems.couponPrice;
      } else {
        const long = this.summaryItems.registrants.length;
        this.checkbox_ = [];
        for(let i = 0; i < long; i++) {
          if((this.summaryItems.registrants[i].id == this.userId) || this.summaryItems.registrants[i].id == null) {
            this.summaryItems.registrants[i].checked = true;
            this.checkbox_.push(this.summaryItems.registrants[i].item+'-'+this.summaryItems.registrants[i].userId+'-'+this.summaryItems.registrants[i].id);        
          } else {
            this.summaryItems.registrants[i].checked = false;
          }
            
        }
        const arrayBuddies = this.summaryItems.registrants.filter((el) => {
          return el.checked && el.id;
        }).map((el) => {
          return el.id;
        });
        const buddies = arrayBuddies.toString();
        PaymentService.registerEventSummary(this.eventId,this.userId,buddies).then(response => {
          if(response.data.success == 1){
              this.total = parseFloat(response.data.message.total).toFixed(2);
              this.subtotal = parseFloat(response.data.message.subtotal).toFixed(2);
              this.tax = parseFloat(response.data.message.tax).toFixed(2);
              this.couponPrice = parseFloat(response.data.message.couponPrice).toFixed(2);
          } else {
      this.subtotal = 0;
      this.total = 0;
      this.checkbox_ = [];

      if(newValue){
        for(var i = 0; i < this.registrants; i ++){
          this.subtotal += parseFloat(this.summaryItems.registrants[i].cost); 
        }
        this.total = parseFloat(this.summaryItems.tax) + this.subtotal;
        this.subtotal = this.subtotal.toFixed(2);
        this.total = this.total.toFixed(2);
      } else {
        for(var j = 0; j < this.summaryItems.registrants.length; j++){
          if(this.summaryItems.registrants[j].userId == this.userId){
            this.subtotal += parseFloat(this.summaryItems.registrants[j].cost);
          }
        }
        this.total = parseFloat(this.summaryItems.tax) + this.subtotal;
        this.subtotal = this.subtotal.toFixed(2);
        this.total = this.total.toFixed(2);
      }      
          }
        });
      } 
      this.refreshSubItem();
    },
    refreshSubItem() {
        for(let i = 0; i < this.summaryItems.registrants.length; i++) {
          let reg = this.summaryItems.registrants[i];
          if(reg.isUserId == 0) {
            let find = this.summaryItems.registrants.filter((el) => {
              return el.isUserId == 1 && reg.userId == el.userId;
            });
            if(find.length > 0) {
              this.summaryItems.registrants[i].checked = find[0].checked;
            }
          }
        }
    },
    async getUser(){
      await AuthService.getUserCurrent().then(response => {
        if (response.data.success == 1) {
            this.userId = response.data.message.id;
            /*let imgUser = response.data.message.existFile 
                    ? this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+"/laravel/public"+response.data.message.image 
                    : require("@/assets/images/partPlaceholder.jpg")
                    ? this.$store.getters.env.get('VUE_APP_DEV_API_HOST') + response.data.message.image
                    : require("@/assets/images/partPlaceholder.jpg");
            //this.$emit("imageUser", imgUser);*/
            this.registerEventSummary();
        }
      });
    },
    async registerEventSummary() {
      await PaymentService.registerEventSummary(this.eventId,this.userId).then(response => {
        if(response.data.success == 1){
            response.data.message.total = parseFloat(response.data.message.total).toFixed(2);
            response.data.message.subtotal = parseFloat(response.data.message.subtotal).toFixed(2);
            response.data.message.tax = parseFloat(response.data.message.tax).toFixed(2);
            response.data.message.couponPrice = parseFloat(response.data.message.couponPrice).toFixed(2);
            this.registrantsItems = response.data.message.registrants;
            this.registrationType = response.data.message.registrationType;
            
            this.registrants = Object.keys(response.data.message.registrants).length;
            for(var i = 0; i < this.registrants; i ++){
              response.data.message.registrants[i].cost = parseFloat(response.data.message.registrants[i].cost).toFixed(2);
              response.data.message.registrants[i].checked = true;
            }
            this.summaryItems = response.data.message;
            this.checkboxAll = true;
            for(var k = 0; k < this.registrants; k ++){
                this.checkbox_.push(this.summaryItems.registrants[k].item+'-'+this.summaryItems.registrants[k].userId+'-'+this.summaryItems.registrants[k].id);        
            }
            this.tax = parseFloat(response.data.message.tax).toFixed(2);
            this.taxes = response.data.message.taxes.map((tax) => {
              return { ...tax, taxAmount: parseFloat(tax.taxAmount).toFixed(2) };
            });
            this.subtotal = response.data.message.subtotal;
            this.total = response.data.message.total;
            this.couponPrice = response.data.message.couponPrice;
            this.registeredBy = response.data.message.registeredBy;
            this.$emit("summaryItems", this.summaryItems);  
        }   
        if (typeof this.$route.query.registrants !== "undefined"){
            let _route = this.$route.query.registrants;
            this.$route.query.registrants = _route.toString().split(',');
            var aux = this.summaryItems.registrants;
            this.summaryItems.registrants = [];
            this.subtotal = this.total = this.tax = this.couponPrice = 0;

            for(var j = 0; j < this.$route.query.registrants.length; j ++){
              this.summaryItems.registrants[j] = aux.find(x => x.item+'-'+x.userId+'-'+x.id === this.$route.query.registrants[j]);
            }
            const arrayBuddies = this.summaryItems.registrants.map((el) => {
              return el.id;
            });
            const buddies = arrayBuddies.toString();
            PaymentService.registerEventSummary(this.eventId,this.userId,buddies).then(response => {
            if(response.data.success){
              this.total = parseFloat(response.data.message.total).toFixed(2);
              this.subtotal = parseFloat(response.data.message.subtotal).toFixed(2);
              this.tax = parseFloat(response.data.message.tax).toFixed(2);
              this.couponPrice = parseFloat(response.data.message.couponPrice).toFixed(2);
              this.registeredBy = response.data.message.registeredBy;
            } else {
              this.subtotal = parseFloat(this.summaryItems.subtotal).toFixed(2);
              this.total = parseFloat(this.summaryItems.total).toFixed(2);
              this.tax = parseFloat(this.summaryItems.tax).toFixed(2);
              this.couponPrice = parseFloat(this.summaryItems.couponPrice).toFixed(2);
              this.registeredBy = -1;
          }
      });
        }
      });
    },
    async validate_promo() {
      if(this.promoCode) {
        PaymentService.validateCouponRegister(this.promoCode, this.regId).then(response => {
          if(response.data.success) {
            this.discount_ = {
              idCoupon: response.data.message.id,
              code: response.data.message.code,
              name: response.data.message.name,
              value: response.data.message.value,
              usesPerCoupon: response.data.message.usesPerCoupon,
              usesPerCustomer: response.data.message.usesPerCustomer,
              codeType: response.data.message.couponType
            };
            if(!this.discount || this.discount.idCoupon != this.discount_.idCoupon) {
                this.registerEventSummary();
            }
          } else {
            this.bandError = true;
            this.msg_snackbar = this.$t('unPaidRegistration.invalid-coupon');
            this.color_snackbar = 'error';
            this.snackbar = true;
            setTimeout(function(){ 
              this.snackbar = false;
            }.bind(this), 3000);
  }
        });
      }
    }
  },
  watch: {
    promoCode() {
      this.bandError = false;
    }
  }
};
</script>

<style>
.grayC {
  background: #ccc;
}
.btn_next{
  color: white !important;
}
.buttons .btn_next {
  margin-right: 10px !important;
}
.cont-inp-promo {
  min-width: 250px; 
  width: 100%; 
  max-width: 300px; 
  margin-left: auto; 
  margin-right: 10px;
}
.cont-btn-promo {
  min-width: 200px; 
  width: 100%; 
  max-width: 200px;
}
.cont-inp-promo label {
  background-color: #fff;
  border-radius: 10px;
  padding: 0 5px;
}
.errorPromo .v-input__slot fieldset, .errorPromo:focus .v-input__slot fieldset {
  background: red;
  border: 1px solid red;
}
.errorPromo label, .errorPromo:focus label {
  color: red !important;
  border-radius: 10px;
}
.errorPromo input, .errorPromo:focus input {
  color: white !important;
  font-weight: 500;
}
@media (max-width: 671px) {
  .v-expansion-panel--active>.v-expansion-panel-header {
    height: auto !important;
  }
  .buttons .btn_next, .buttons .v-input {
    margin-top: 10px;
  }
  .cont-inp-promo, .cont-btn-promo {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
  }
  .cont-btn-promo {
    margin-top: -43px;
  }
}
@media (max-width: 574px) {
  .cont-inp-promo {
    margin-right: 0;
  }
  .buttons .btn_next, .cont-btn-promo .btn_next {
    min-width: 0;
    white-space: normal;
    display: block;
    width: auto;
    margin-left: auto;
    margin-right: auto !important;

  }
}
.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
    height: 23px;
}
</style>
